import { render, staticRenderFns } from "./labelInfo.vue?vue&type=template&id=f595ab98&scoped=true"
import script from "./labelInfo.vue?vue&type=script&lang=ts"
export * from "./labelInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f595ab98",
  null
  
)

export default component.exports